import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
/* import {NgbButtonsModule} from "@ng-bootstrap/ng-bootstrap"; */
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { CmsConfig, ConfigModule, I18nModule, UrlModule } from '@spartacus/core';
import { FormErrorsModule } from "@spartacus/storefront";
import { CustomNewsletterComponent } from './custom-newsletter.component';


@NgModule({
  declarations: [CustomNewsletterComponent],
  exports: [
    CustomNewsletterComponent,
  ],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        NewsletterComponent: {
          component: CustomNewsletterComponent,
        },
      },
    } as CmsConfig),
    I18nModule,
    FormErrorsModule,
    UrlModule,
    RouterModule,
    /*  NgbButtonsModule, */
    ReactiveFormsModule,
  ],
})
export class CustomNewsletterModule { }
